var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquares(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 131,
    viewBox: "0 0 160 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5ACBBC",
    stroke: "#000",
    strokeWidth: 5.794,
    d: "M16.227 74.834L4.002 16.225 62.61 4 74.835 62.61zM97.39 127.278L85.167 68.669l58.608-12.225L156 115.053z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYwIiBoZWlnaHQ9IjEzMSIgdmlld0JveD0iMCAwIDE2MCAxMzEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cmVjdCB4PSIxNi4yMjY2IiB5PSI3NC44MzQiIHdpZHRoPSI1OS44NzAzIiBoZWlnaHQ9IjU5Ljg3MDMiIHRyYW5zZm9ybT0icm90YXRlKC0xMDEuNzgyIDE2LjIyNjYgNzQuODM0KSIgZmlsbD0iIzVBQ0JCQyIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSI1Ljc5NDI3Ii8+CiAgICA8cmVjdCB4PSI5Ny4zOTA2IiB5PSIxMjcuMjc4IiB3aWR0aD0iNTkuODcwMyIgaGVpZ2h0PSI1OS44NzAzIiB0cmFuc2Zvcm09InJvdGF0ZSgtMTAxLjc4MiA5Ny4zOTA2IDEyNy4yNzgpIiBmaWxsPSIjNUFDQkJDIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjUuNzk0MjciLz4KPC9zdmc+Cg==";
export { SvgSquares as ReactComponent };